<template>
  <div id="app">
    <div class="wx-pages">
      <v-touch v-on:swipeleft="swiperleft" :swipe-options="{direction: 'horizontal'}" class="wrapper">
        <transition :name="transitionName">
          <!-- 缓存数据 <router-view> -->
          <router-view class="page"></router-view>
        </transition>
      </v-touch>
    </div>

  </div>
</template>

<script>

import jump from "./common/jump";
import {gzhLogin, miniwxLogin} from "./common/api/index/index.js"

export default {
  name: 'app',
  data() {
    return {
      transitionName: "slide-left",
      show: false
    }
  },
  created() {
  },
  mounted() {
    console.log('app.vue')
    this.$nextTick(() => {
      this.login()
    })
    jump.$on('back', (data) => {
      this.back(data);
    })
    jump.$on('goNext', (data) => {
      this.goNext(data);
    })
  },

  /* 页面切换动画 */
  watch: {},
  methods: {
    swiperleft: function () {
      this.transitionName = "aaa"
    },
    back() {
      this.transitionName = "slide-right";
    },
    goNext() {
      this.transitionName = "slide-left";

    },
    login() {
      /**
       * 兼容两种参数位置：
       * 1. hash后面：https://域名/#/index?appid=xxx&code=xxx  （标准小程序跳转）
       * 2. search后面：https://域名/?appid=xxx&code=xxx#/index （微信webview追加参数时）
       * 3. 公众号后端重定向：https://域名/#/index?token=xxx
       */
      const searchParams = new URLSearchParams(window.location.search)
      const hashParams = new URLSearchParams((window.location.hash.split('?')[1] || ''))

      const appid = searchParams.get('appid') || hashParams.get('appid')
      const code = searchParams.get('code') || hashParams.get('code')
      const token = searchParams.get('token') || hashParams.get('token')

      console.log('login params => appid:', appid, 'code:', code, 'token:', token)
      console.log('search:', window.location.search, 'hash:', window.location.hash)

      let that = this

      if (appid && code) {
        // 小程序环境：带appid和code，调用小程序登录接口换取token
        miniwxLogin(appid, code).then(res => {
          console.log('登录结果:', res)
          if (res && res.code === 200 && res.data && res.data.token) {
            that.token = that.$cookies.set('token', res.data.token, 21600)
          } else {
            console.error('小程序登录接口返回异常:', res)
          }
          /**通知index刷新（无论登录成败都让首页渲染出来，避免白屏）*/
          jump.$emit('refresh')
        }).catch(err => {
          console.error('小程序登录请求失败:', err)
          jump.$emit('refresh')
        })
      } else if (token) {
        // 公众号环境：后端重定向已携带token，直接存储
        that.token = that.$cookies.set('token', token, 21600)
        /**通知index刷新 */
        jump.$emit('refresh')
      } else {
        console.warn('login: 未检测到appid/code或token，尝试用已有token加载，当前URL:', window.location.href)
        /**无登录参数但cookie中可能已有token，通知index尝试加载数据 */
        jump.$emit('refresh')
      }
    }
    // login() {
    //   let hrefs = window.location.href
    //   let token = hrefs.split("=")
    //   let appOrToken = token[0].slice(-5)
    //   //判断公众号（带appid是小程序未授权，带token是appid授权，同小程序）or小程序
    //   if (appOrToken == "appid") {
    //     // window.location.href = 'http://h5.hzjf.top/wx/portal/'+token[1]
    //     // console.log('路由参数:', this.$route)
    //     // console.log('参数appid:', this.$route.query.appid, '参数code:', this.$route.query.code)
    //     // let appid = this.$route.query.appid
    //     // let code = this.$route.query.code
    //     let that = this
    //     const code = hrefs.slice(hrefs.indexOf('code') + 5)
    //     miniwxLogin('wx057a3d26834aa8ad', code).then(res => {
    //       console.log('登录参数:', res)
    //       that.token = this.$cookies.set('token', res.data.token, 21600)
    //       // that.allRefresh()
    //       /**通知index刷新 */
    //       jump.$emit('refresh')
    //
    //     })
    //   } else {
    //     // const urlParams = new URLSearchParams(window.location.search)
    //     // const code = urlParams.get('code')
    //     if (token[1] == undefined) {
    //     } else {
    //       this.token = this.$cookies.set('token', token[1], 21600)
    //     }
    //     // this.allRefresh()
    //     /**通知index刷新 */
    //     jump.$emit('refresh')
    //   }
    // }
  }
}
</script>

<style>
#app {
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0;
  margin: 0
}

/* 页面切换动画 */
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  /* will-change属性可以提前通知浏览器我们要对元素做什么动画，这样浏览器可以提前准备合适的优化设置 */
  will-change: transform;
  transition: all ease 0.4s;
  -webkit-transition: all ease 0.4s;
  position: absolute;
  width: 100%;
  left: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}

.slide-right-leave-active {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.slide-left-enter {
  transform: translateX(100%);
  -webkit-transform: translateX(100%);
}

.slide-left-leave-active {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}

</style>
